
import Vue from 'vue'

import SecurityPhotoTransformer from '@/transformers/workPlan/securityPhoto'

function paramsTransformer(params) {
  return {
    date: params.day,
    extranet: params.extranet
  }
}

export default (opts={}) => { 
	let url = 'workplan/security-photo/'

  const {realPlan, day, affected, extranet} = opts

	if (realPlan) {
		url += `plan_real/${realPlan}/`
	} else if (affected) {
    url += `by_affected/${affected}/`
  }

  const params = paramsTransformer({day, extranet})

	return Vue.$http.get(url, { params })
		.then(response => {
			return SecurityPhotoTransformer.fetchCollection(response.data)
		})
}




// WEBPACK FOOTER //
// ./src/services/workPlan/fetchSecurityPhotos.js